import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class KnowledgeDocumentId extends IdValueObject {
  static create(value: string): KnowledgeDocumentId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeDocumentId(value);
  }
}
